(ns bedrock-ui.sentry.fx
  (:require #?(:cljs ["@sentry/browser" :refer [init captureMessage showReportDialog configureScope]])
            [clojure.string :as string]
            [medley.core :as medley]
            [re-frame.core :as rf]))

(defn set-context
  [context]
  #?(:cljs (configureScope
             #(doall
                (for [[k v] context]
                  (.setExtra % (clj->js k) (clj->js v)))))))

(defn set-user
  [user]
  #?(:cljs (configureScope
             #(.setUser % (clj->js user)))))

(rf/reg-fx
 ::init
 (fn [opts]
   #?(:cljs (init (clj->js opts)))))

(rf/reg-fx
 ::set-user
 (fn [user]
   (when user
     (set-user user))))

(rf/reg-fx
 ::capture-message
 (fn [{:keys [message] :as opts}]
   (set-context (dissoc opts :message))
   #?(:cljs (captureMessage (clj->js message)))))

;; Don't call this directly, call 'bedrock-ui.sentry.handlers/show-report-dialogue'
(rf/reg-fx
 ::show-report-dialogue
 (fn show-report-dialogue
   [{:keys [first-name last-name primary-email] :as user}]
   (let [name (string/trim (string/join " " [first-name last-name]))
         user (medley/assoc-some nil
                                 :email primary-email
                                 :name (when-not (empty? name) name))]
     #?(:cljs (showReportDialog (clj->js {:user user}))))))
